const GUIDE_IMAGES = {
  welcome: "/onboarding/axon-guide-welcome.webp",
  choose: "/onboarding/axon-guide-choose.webp",
  review: "/onboarding/axon-guide-review.webp",
  success: "/onboarding/axon-guide-success.webp",
  notice: "/onboarding/axon-guide-notice.webp",
};

export function AxonGuide({ state = "welcome", className = "" }) {
  const source = GUIDE_IMAGES[state] || GUIDE_IMAGES.welcome;
  return (
    <img
      className={`axon-guide${className ? ` ${className}` : ""}`}
      src={source}
      alt=""
      aria-hidden="true"
      decoding="async"
      draggable="false"
    />
  );
}
